// extracted by mini-css-extract-plugin
export default {"opcontainer":"Myorders_opcontainer__Uih96"};